var _g, _g2, _g3, _g4, _g5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 284,
    height: 24,
    viewBox: "0 0 284 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22_7427)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 17.27L18.18 21L16.54 13.97L22 9.24L14.81 8.63L12 2L9.19 8.63L2 9.24L7.46 13.97L5.82 21L12 17.27Z",
    fill: "#0802B9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_22_7427)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 17.27L46.18 21L44.54 13.97L50 9.24L42.81 8.63L40 2L37.19 8.63L30 9.24L35.46 13.97L33.82 21L40 17.27Z",
    fill: "#0802B9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_22_7427)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68 17.27L74.18 21L72.54 13.97L78 9.24L70.81 8.63L68 2L65.19 8.63L58 9.24L63.46 13.97L61.82 21L68 17.27Z",
    fill: "#0802B9"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_22_7427)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96 17.27L102.18 21L100.54 13.97L106 9.24L98.81 8.63L96 2L93.19 8.63L86 9.24L91.46 13.97L89.82 21L96 17.27Z",
    fill: "#0802B9"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_22_7427)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134 9.24L126.81 8.62L124 2L121.19 8.63L114 9.24L119.46 13.97L117.82 21L124 17.27L130.18 21L128.55 13.97L134 9.24ZM124 15.4L120.24 17.67L121.24 13.39L117.92 10.51L122.3 10.13L124 6.1L125.71 10.14L130.09 10.52L126.77 13.4L127.77 17.68L124 15.4Z",
    fill: "#0802B9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22_7427"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_22_7427"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(28)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_22_7427"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(56)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_22_7427"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(84)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_22_7427"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(112)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/Stars.494ab590e77126abb128bd8bbc323f44.svg";
export { ForwardRef as ReactComponent };